function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.00003 10.9167C0.996018 12.4565 1.35578 13.9755 2.05003 15.35C2.87319 16.997 4.13865 18.3824 5.70467 19.3508C7.27068 20.3193 9.0754 20.8326 10.9167 20.8333C12.4565 20.8374 13.9755 20.4776 15.35 19.7833L22 22L19.7833 15.35C20.4776 13.9755 20.8373 12.4565 20.8333 10.9167C20.8326 9.0754 20.3193 7.27068 19.3508 5.70467C18.3824 4.13865 16.997 2.87319 15.35 2.05003C13.9755 1.35579 12.4565 0.996018 10.9167 1.00003H10.3334C7.90162 1.13419 5.60481 2.16059 3.8827 3.8827C2.16059 5.60481 1.13419 7.90162 1.00003 10.3334V10.9167Z",
  stroke: "#2B1C1C",
  strokeOpacity: 0.5,
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgInterviewingicon = function SvgInterviewingicon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInterviewingicon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/interviewingicon.8d2ab02c.svg";
export { ForwardRef as ReactComponent };